export enum AddressType {
  Billing = 'BILLING',
  Trading = 'TRADING',
  Delivery = 'DELIVERY',
}
